import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Text from './Text';
import Icon from './Icon';
import { palette } from '../../constants/styles';

const StyledStepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100vw;
`;

const StyledStep = styled.div`
  width: ${({ width }) => `${width}%`};
  height: 5px;
  // border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-image: ${({ isFocused }) => (isFocused ? 'linear-gradient(-225deg, #50E3C2 0%, #08AEEA 100%)' : 'none')};
  // border-style: solid;
  // border-width: 1px;
  background-color: ${({ isFocused, isDone }) => {
    let color = 'none';
    if (isDone) {
      color = palette.secondaryColor;
    } else if (isFocused) {
      color = 'none';
    }
    return color;
  }};
`;

const getArrayOfNumbers = (number) => {
  let i;
  const arrayOfNumbers = [];
  for (i = 1; i < number + 1; i += 1) {
    arrayOfNumbers.push(i);
  }
  return arrayOfNumbers;
};

const StepCounter = ({
  currentStep,
  numberOfSteps,
}) => {
  const numberArray = getArrayOfNumbers(numberOfSteps);
  return (
    <StyledStepsContainer>
      {numberArray.map(number => (
        <StyledStep width={100 / numberOfSteps} isFocused={currentStep === number} isDone={currentStep > number} />
      ))}
    </StyledStepsContainer>
  );
};

StepCounter.propTypes = {
  currentStep: PropTypes.number,
  numberOfSteps: PropTypes.number,
};

StepCounter.defaultProps = {
  currentStep: 1,
  numberOfSteps: 5,
};

export default StepCounter;